<template>
  <v-main>
    <v-app-bar
      fixed
      color="grey lighten-4"
      dense
      flat
    >
      <v-btn
        icon
        :to="($i18n.locale == 'en') ? '/en' : '/'"
      >
        <v-icon color="primary">mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title>ポジショニングマップ.COMについて</v-toolbar-title>

    </v-app-bar>

    <v-container mt-12 py-6 px-6>
      <h1>二軸でモノを比較する</h1>
      <p class="desc">ポジショニングマップ.COMは、二軸でモノを比較、可視化します。<br>
      二軸で比較するだけでも、物事の判断の助けになります。</p>

      <p class="mt-8">ポジショニングマップ.COMは、以下の用途などでご利用いただけると思います。</p>
      <ul>
        <li>マーケティング戦略</li>
        <li>商品戦略</li>
        <li>企業戦略</li>
        <li>商品選び</li>
        <li>学校選び</li>
        <li>会社選び</li>
        <li>比較したい物事すべて</li>
      </ul>

      <p class="mt-8">旧ポジショニングマップ.COMを2013年に開発し、1,000以上ものポジショニングマップが公開されています。<br>
      今も現役で使われいますが、古く拡張性に乏しいため、リニューアルすることにしました。<br>
      残念ながら、互換性はございません。全く新しいポジショニングマップ.COMとなります。</p>
      <v-btn
        link
        depressed
        color="teal"
        href="/v1/"
      >
        <span class="white--text">旧ポジショニングマップ.COMはこちら</span>
      </v-btn>
      <p class="mt-8">姉妹サイトの「相関図作成ツール」もあります。<br>
      「ポジショニングマップ.COM」は、相関図作成ツールから派生してできたものです。</p>
      <v-btn
        link
        depressed
        color="primary"
        href="https://diagram.jp/"
      >
        相関図作成ツールはこちら
      </v-btn>

      <p class="mt-8">最近はたまにTwitter発信しています。</p>
      <p><a href="https://twitter.com/AssistGoal?ref_src=twsrc%5Etfw" class="twitter-follow-button" data-show-count="false">Follow @AssistGoal</a></p>
    </v-container>
  </v-main>
</template>

<script>
export default {
  metaInfo: {
    title: 'ポジショニングマップ.COMについて',
    meta: [
      { name: 'description', content: 'ポジショニングマップをブラウザ上で作成できます。' }
    ]
  }
}
</script>

<style lang="scss" scoped>
h1 {
  line-height: 1.8;
  font-size: 32px;
  font-weight: bold;
}
.desc {
  line-height: 1.8;
  font-size: 20px;
  font-weight: bold;
  margin-top: 16px;
}
</style>
